module.exports = __webpack_public_path__ + "static/media/032.e76a7ce2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/people/normals/032.jpg
// module id = 328
// module chunks = 0